// @flow
import React, { type Node } from 'react';

import useRecipientsData from './useRecipientsData';
import useSchools from '../useSchools';
import RecipientsContext from './RecipientsContext';


type Props = {
  children: Node,
}

const RecipientsData = ({ children }: Props) => {
  const [, schoolsIds] = useSchools();
  const data = useRecipientsData(schoolsIds);

  return (
    <RecipientsContext.Provider value={data}>
      {children}
    </RecipientsContext.Provider>
  );
};

export default RecipientsData;
